export const goToUrl = (url: string) => {
  if (!url) return
  if (url.includes(process.env.REACT_APP_DOMAIN!)) {
    window.open(url, '_self')
  } else {
    window.open(url, '_blank')
  }
}
